// Function loadFeatureArticleHero loads the FeatureArticleHero class by dynamically importing the js on demand if needed

export function loadFeatureArticleHero($parentEl, isList = false) {


	let $wg = $parentEl.querySelector('[data-wg="FeatureArticleHero"]');

	if(!$wg) {
		// console.info('FeatureArticleHero: no widget found');
		return Promise.reject('FeatureArticleHero widget not found in the parent element');
	}

	return import(/* webpackChunkName: "wg-feature-article-hero-chunk" */ '../widgets/featureArticleHero').then(wg => {

		const { FeatureArticleHero } = wg;

		if (isList) {
			let $wgCol = $parentEl.querySelectorAll('[data-wg="FeatureArticleHero"]');
			let instances = [];
			Array.from($wgCol).forEach(($wg, i) => {
				instances.push( new FeatureArticleHero($wg) );
			});
			if (instances.length === $wgCol.length) return instances;

		} else {
			return new FeatureArticleHero($wg);
		}


	}).catch(error => error+'An error occurred while loading the FeatureArticleHero widget');

}
